var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.133,
    height: 23.289,
    viewBox: "0 0 24.133 23.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }), /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__icon_message-circle",
    "data-name": "icon / message-circle",
    transform: "translate(-10.367 .667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group",
    transform: "translate(11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__phone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    fill: "none",
    stroke: "#117093",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M8.454 6.4a2.244 2.244 0 0 0 0-3.271L5.888.677a2.5 2.5 0 0 0-3.42 0L1.062 2.023A3.351 3.351 0 0 0 .6 6.388a55.066 55.066 0 0 0 15.721 15.034 3.751 3.751 0 0 0 4.564-.437l1.406-1.346a2.242 2.242 0 0 0 0-3.271l-2.565-2.453a2.5 2.5 0 0 0-3.42 0l-.855.818A56.194 56.194 0 0 1 7.6 7.219z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAlert);
export default __webpack_public_path__ + "static/media/call-alert.2e32f1c9f4e4f8f03df9ff759235ca6f.svg";
export { ForwardRef as ReactComponent };